var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWordpress = function SvgWordpress(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 20C.5 9.23 9.23.5 20 .5S39.5 9.23 39.5 20 30.77 39.5 20 39.5.5 30.77.5 20z",
    fill: "#fff",
    stroke: "#3E3D3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.152c0 4.038 2.449 7.528 6 9.181L10.922 16A9.806 9.806 0 0010 20.152M26.665 19.803c0-1.276-.451-2.16-.837-2.847-.515-.85-.997-1.57-.997-2.421 0-.95.707-1.833 1.704-1.833.045 0 .088.006.132.009A10.017 10.017 0 0019.813 10c-3.546 0-6.665 1.85-8.48 4.653.239.008.463.013.653.013 1.062 0 2.705-.131 2.705-.131.547-.033.612.785.065.85 0 0-.55.066-1.161.098l3.696 11.184 2.22-6.776-1.58-4.407c-.547-.033-1.065-.098-1.065-.098-.547-.034-.483-.884.065-.851 0 0 1.675.13 2.673.13 1.06 0 2.705-.13 2.705-.13.547-.033.611.785.064.85 0 0-.55.066-1.161.098l3.668 11.098 1.012-3.44c.438-1.429.773-2.454.773-3.338",
    fill: "#3E3D3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.263 20.667l-2.93 8.916a9.35 9.35 0 006-.163.973.973 0 01-.07-.14l-3-8.613zM29.353 15.333c.046.332.072.688.072 1.071 0 1.057-.204 2.245-.816 3.731l-3.276 9.198c3.19-1.805 5.334-5.16 5.334-9.003a10.13 10.13 0 00-1.314-4.997",
    fill: "#3E3D3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20c0-6.617 5.383-12 12-12s12 5.383 12 12-5.383 12-12 12S8 26.617 8 20zm.55 0c0 6.313 5.137 11.45 11.45 11.45S31.45 26.313 31.45 20 26.313 8.55 20 8.55 8.55 13.686 8.55 20z",
    fill: "#3E3D3A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWordpress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wordpress.4185ac3d3144d70cd73f9505d431f352.svg";